import React, { type MouseEvent } from 'react';

import Pin from '../pin';
import Share from '../share';
import humanFile from '../../utils/human-file';
import { findGetParameter } from '../../utils/parameters';
import { DOWNLOAD_TYPE } from '../../constants';
import { getConfig } from '../../utils/config';
import type { IItem } from '../../types';

interface FileEntryProps extends IItem {
  loginRequired: boolean;
  attributes: Array<{ facetname: string }>;
  handleDownload: (e: MouseEvent<HTMLAnchorElement>) => void;
  groupId: number;
  [restAttributes: string]: any;
}

export default function FileEntry({
  dfAttributeDfFileType: fileType,
  dfAttributeDfFileSize: fileSize,
  pimId: id,
  groupId,
  handleDownload,
  attributes,
  type,
  ...restAttributes
}: FileEntryProps): React.ReactElement {
  const cmsNativeLanguage = getConfig('cms_native_language', 'EN-EN')?.toLocaleLowerCase();
  const domain = getConfig('download_url_prefix', '');
  const isSelected = findGetParameter('download_item') === String(id);
  const loginRequired = type === DOWNLOAD_TYPE.LOGIN;
  const relativeFilePath = `${cmsNativeLanguage}/download/${id}`;
  const downloadLink = `${domain}/${relativeFilePath}`;

  return (
    <tr className={isSelected ? 'df-shared-bookmark' : ''}>
      {attributes.map((attribute) => (
        <td key={attribute.facetname}>
          {typeof restAttributes[attribute.facetname] === 'object'
            ? restAttributes[attribute.facetname].join(', ')
            : restAttributes[attribute.facetname]}
        </td>
      ))}
      <td>
        <a
          href={downloadLink}
          onClick={handleDownload}
          className={`df-download-link  ${loginRequired ? 'df-download-link__login-required' : ''}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          {fileType} {Boolean(fileSize) && `(${humanFile(fileSize)})`}
        </a>
      </td>
      <td>
        <div className="df-list-module__table__actions">
          <Pin id={id} group={groupId} />
          <Share group={groupId} item={id} type="item" />
        </div>
      </td>
    </tr>
  );
}
